import React from 'react';

export const useSaveSearchState = () => {
    const [ isOpenSaveSearch, toggleSaveSearch ] = React.useState(false);

    const openSaveSearch = React.useCallback(() => {
        toggleSaveSearch(true);
    }, []);

    const closeSaveSearch = React.useCallback(() => {
        toggleSaveSearch(false);
    }, []);

    return {
        isOpenSaveSearch,
        openSaveSearch,
        closeSaveSearch
    };
};
